var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgKeyboardArrowLeft24Px = function SvgKeyboardArrowLeft24Px(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 8 12",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.99999 9.87499L3.11999 5.99499L6.99999 2.11499C7.38999 1.72499 7.38999 1.09499 6.99999 0.704992C6.81316 0.517739 6.55951 0.412506 6.29499 0.412506C6.03047 0.412506 5.77682 0.517739 5.58999 0.704992L0.999989 5.29499C0.609989 5.68499 0.609989 6.31499 0.999989 6.70499L5.58999 11.295C5.97999 11.685 6.60999 11.685 6.99999 11.295C7.37999 10.905 7.38999 10.265 6.99999 9.87499Z"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgKeyboardArrowLeft24Px);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "keyboard_arrow_left_24px.61c83fa2110ebcd2c6e7d7403787a671.svg";